import { useEffect, useRef, useState } from "react";

function Scaled({ w, h, children, maxW }) {
  const wrapRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const fit = () => {
      const avail = Math.min(el.clientWidth, maxW || el.clientWidth);
      setScale(Math.min(1, avail / w));
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [w, maxW]);

  return (
    <div ref={wrapRef} className="w-full">
      <div style={{ height: h * scale, width: w * scale }}>
        <div
          style={{
            width: w,
            height: h,
            transform: `scale(${scale})`,
            transformOrigin: "top left",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export function DesktopFrame({ children, label = "udyogclasses.com" }) {
  return (
    <div className="flex-1 min-w-0" data-testid="desktop-frame">
      <div className="rounded-xl border border-white/10 bg-[#141414] overflow-hidden shadow-[0_20px_60px_-20px_rgba(0,0,0,0.9)]">
        <div className="h-8 flex items-center gap-2 px-3 border-b border-white/10 bg-[#1a1a1a]">
          <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#febc2e]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#28c840]" />
          <div className="ml-3 px-3 py-0.5 rounded-md bg-black/50 text-[10px] text-neutral-500 font-mono">
            {label}
          </div>
        </div>
        <Scaled w={1440} h={860}>
          {children}
        </Scaled>
      </div>
      <div className="mt-2 text-[10px] uppercase tracking-[0.24em] text-neutral-600">Desktop · 1440px</div>
    </div>
  );
}

export function MobileFrame({ children }) {
  return (
    <div className="shrink-0" style={{ width: 300 }} data-testid="mobile-frame">
      <div className="rounded-[38px] border border-white/12 bg-black p-2 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.9)]">
        <div className="relative rounded-[30px] overflow-hidden">
          <div className="absolute top-2 left-1/2 -translate-x-1/2 z-30 w-20 h-5 rounded-full bg-black/90 border border-white/10" />
          <Scaled w={390} h={844} maxW={284}>
            {children}
          </Scaled>
        </div>
      </div>
      <div className="mt-2 text-[10px] uppercase tracking-[0.24em] text-neutral-600">Mobile · 390px</div>
    </div>
  );
}
